import React from 'react';
import { render } from "react-dom";
import { CookiesProvider } from 'react-cookie';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './queryClient';
import App from "./App";
import './index.css';

render(
  <React.StrictMode>
    <CookiesProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </CookiesProvider>
  </React.StrictMode>,
  document.getElementById('root')
);
